// define a mixin object
/*eslint-disable*/
import DialogOperationRunning from '@/components/DialogOperationRunning'
import DialogError from '@/components/DialogError'
import DialogInfo from "@/components/DialogInfo"
import BreadCrumbs from '@/components/commons/BreadCrumbs'

export default {
  components: {
    DialogOperationRunning,
    DialogError,
    DialogInfo,
    BreadCrumbs,
  },
  data () {
    return {
      operationRunningTitle: 'INFO',
      dialogStampeModel:false,
      dialogSmsModel:false,
      dialogNotificheModel:false,
      errorDialogTitle:""
    }
  },
  created: function () {
    if (this.$session.get('uuid')==null) {
      this.$router.push({ path: '/Login/' })
    }
    this.$store.commit("setProgressMessage", null);
    this.$store.commit("setErrorMessage", null);

    document.addEventListener("mouseup", e => {
      let parameters= {}
      this.$store.dispatch("checkSession",parameters);
    })
  },
  methods: {
    loginEffettuato: function() {
      if (this.$session.get("uuid") == null) return false;
      else return true;
    },
    isClienteSelezionato(){
      if(this.$store.getters.cliente!=null)
       return true
      return false
    },
    showErrorDialog(message) {
      this.$store.commit("setProgressMessage", null);
      this.$store.commit("setInfoMessage", null);
      this.$store.commit("setErrorMessage", message);
    },
    showLoadingDialog(show, message = "") {
      if (show) {
        this.$store.commit("setErrorMessage", null);
        this.$store.commit("setInfoMessage", null);
        this.$store.commit("setProgressMessage", message);
      } else {
        this.$store.commit("setProgressMessage", null);
      }
    },
    showSuccessDialog(message, time = 3000) {
      this.$store.commit("setErrorMessage", null);
      this.$store.commit("setInfoMessage", null);
      this.$store.commit("setProgressLoading", false);
      this.$store.commit("setProgressMessage", message);
      var that = this
      setTimeout(function () {
        that.$store.commit("setProgressMessage", null);
        that.$store.commit("setProgressLoading", true);
      }, time)
    },
    showInfoDialog(message) {
      this.$store.commit("setErrorMessage", null);
      this.$store.commit("setProgressLoading", true);
      this.$store.commit("setProgressMessage", null);
      this.$store.commit("setInfoMessage", message);
    },
  },
  computed: {
    progressMessage: function () {
      // console.log('progressMessage')
      return this.$store.state.progressMessage
    },
    progressMessageEnable: function () {
      // console.log('progressMessageEnable')
      if (this.$store.state.progressMessage == null) {
        return false
      } else {
        return true
      }
    },
    progressLoading: function(){
      return this.$store.state.progressLoading;
    },
    errorMessage: function () {
      return this.$store.state.errorMessage
    },
    infoMessage: function () {
      return this.$store.state.infoMessage
    },
    infoMessageEnable: function () {
      if (this.$store.state.infoMessage == null) {
        console.log("infoMessageEnable --> true");
        return false;
      } else {
        console.log("infoMessageEnable --> false");
        return true;
      }
    },
    errorMessageEnable: function() {
      if (this.$store.state.errorMessage == null) {
        console.log("errorMessageEnable --> false");
        return false;
      } else {
        console.log("errorMessageEnable --> true");
        return true;
      }
    },
    breadcrumbsitems: function () {
      return this.$store.state.breadcrumbsitems
    }
  }
}
